import User from "src/components/User";
import { Observer } from 'mobx-react';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export default (() => { return /*#__PURE__*/ _jsx(_Fragment, { children: /*#__PURE__*/ _jsx(Observer, { children: () => { var _User$meta; return /*#__PURE__*/ _jsx(_Fragment, { children: ((_User$meta = User.meta) === null || _User$meta === void 0 ? void 0 : _User$meta.balance) || 0 }); } }) }); });
